// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__xRbaX","rootCenter":"LoadMoreObserver_rootCenter__1QEdX","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__11nJn"};